import * as React from 'react';
import SVG from 'react-inlinesvg';
import IconsSVG from '../../../assets/icons.svg';

function IconLoader() {
  return /*#__PURE__*/React.createElement(SVG, {
    src: IconsSVG,
    style: {
      display: 'none'
    }
  });
}

export default IconLoader;